
//imageSection.jsx1
import React, { useEffect, useState } from "react";
import Fancybox from './Fancybox';
// import { getPageNumber } from "./redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// import axios from "axios";

 let count=4;
 let arr=[];

const ImageSection = ({ part, onChildData }) => {
  
    console.log("PART",part)
    useEffect(()=> {
        for(let i=0; i<part.images.length; i++) {
          if(i==0) arr.push(count);
          else if(window.innerWidth>992 && part.images[i].desk_img=="") count--;
          count++;
        }
        console.log("count: ",count);
    },[]);

  
    onChildData(arr);
    

    // arr && dispatch(getPageNumber(arr));

    // useEffect(() => {
    //   axios.get("localhost:8000/api/frontend/get-all-team")
    //     .then((res) => {
    //       console.log("The response that I got is: ", res);
    //     })
    //     .catch((err) => {
    //       console.log("A new error occurred", err);
    //     });
    // }, []);


    return (
      <>
        {part.images.map((image,index) => (
          ((window.innerWidth > 992 && image.desk_img!=="") || 
           (window.innerWidth < 992 && image.mob_img!=="")) &&  (
            <div key={image.id} className="section">
              <Fancybox options = {{ Carousel: { infinite: false } }}>
               {index===0 ? 
                  <LazyLoadImage 
                    src={`https://madhyadesign.com/api/upload/${image.desk_img}`}
                    alt="no-image"
                    className="desktop-img" 
                    effect="blur"
                    onLoad={() => {
                      if (window.fullpage_api) {
                        window.fullpage_api.reBuild();
                      }
                    }}
                  /> 
                  :
                  <LazyLoadImage 
                    src={`https://madhyadesign.com/api/upload/${image.desk_img}`}
                    alt="no-image"
                    className="desktop-img"
                    data-fancybox={`${part.title}-desktop`} 
                    data-caption={part.title}
                    style={{cursor:"pointer"}}
                    effect="blur"
                    onLoad={() => {
                      if (window.fullpage_api) {
                        window.fullpage_api.reBuild();
                      }
                    }}
                  />
                }
                {index===0 ? 
                  <LazyLoadImage 
                    src={`https://madhyadesign.com/api/upload/${image.mob_img}`}
                    alt="no-image" 
                    className="mobile-img" 
                    effect="blur"
                    onLoad={() => {
                      if (window.fullpage_api) {
                        window.fullpage_api.reBuild();
                      }
                    }}
                  />
                  :
                  <LazyLoadImage
                    src={`https://madhyadesign.com/api/upload/${image.mob_img}`}
                    alt="no-image" 
                    className="mobile-img" 
                    data-fancybox={`${part.title}-mobile`} 
                    data-caption={part.title}
                    style={{cursor:"pointer"}}
                    effect="blur"
                    onLoad={() => {
                      if (window.fullpage_api) {
                        window.fullpage_api.reBuild();
                      }
                    }}
                  />
                
                }
              </Fancybox>
              <h5 className="image-path">
                {part.categories.map((category, index) => (
                  <span key={index}>
                    {category}
                    {index + 1 === part.categories.length ? '' : '+'}
                  </span>
                ))}/{part.title}
              </h5>
            </div>
          )
        ))}
      </>
    );
  };

export default ImageSection;
